import StyledBurger from "./StyledBurger";
import StyledMenu from "./StyledMenu";
import BurgerMenu from "./BurgerMenu";

export default { BurgerMenu, StyledBurger, StyledMenu};